import { makeStyles } from "@material-ui/core/styles";

export const useBillingStyles = makeStyles((theme) => ({
  section: {
    padding: "16px",
    paddingTop: "8px",
    paddingLeft: "0",
    [theme.breakpoints.down("sm")]: {
      padding: "15px",
      backgroundColor: "#1a1a1a",
      paddingBottom: "86px",
    },
  },
  sectionTitle: {
    color: "#f06ec4",
    fontWeight: 600,
    fontSize: "24.5px",
    marginBottom: "32px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
      marginBottom: "24px",
    },
  },

  // New CCBill styles
  ccbillContainer: {
    background: "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)",
    borderRadius: "12px",
    padding: "40px 32px",
    border: "1px solid #363636",
    textAlign: "center",
    maxWidth: "600px",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      padding: "24px 16px",
      margin: "0",
    },
  },

  securityIconContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "24px",
  },

  securityIcon: {
    width: "64px",
    height: "64px",
    color: "#f06ec4",
    [theme.breakpoints.down("sm")]: {
      width: "48px",
      height: "48px",
    },
  },

  ccbillTitle: {
    color: "#ffffff",
    fontSize: "28px",
    fontWeight: 600,
    marginBottom: "16px",
    fontFamily: "Work Sans, sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "24px",
    },
  },

  ccbillDescription: {
    color: "#cccccc",
    fontSize: "16px",
    lineHeight: "1.6",
    marginBottom: "24px",
    fontFamily: "Work Sans, sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },

  ccbillFeatures: {
    color: "#ffffff",
    fontSize: "14px",
    lineHeight: "1.8",
    marginBottom: "32px",
    textAlign: "left",
    background: "#0f0f0f",
    padding: "16px 20px",
    borderRadius: "8px",
    border: "1px solid #2a2a2a",
    fontFamily: "Work Sans, sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      padding: "12px 16px",
    },
  },

  managePaymentButton: {
    backgroundColor: "#f06ec4",
    color: "#ffffff",
    fontSize: "16px",
    fontWeight: 600,
    padding: "12px 32px",
    borderRadius: "8px",
    textTransform: "none",
    marginBottom: "20px",
    fontFamily: "Work Sans, sans-serif",
    "&:hover": {
      backgroundColor: "#d45ca5",
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(240, 110, 196, 0.3)",
    },
    transition: "all 0.3s ease",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      padding: "10px 24px",
      width: "100%",
    },
  },

  ccbillNote: {
    color: "#999999",
    fontSize: "12px",
    lineHeight: "1.5",
    fontStyle: "italic",
    fontFamily: "Work Sans, sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
    },
  },

  // Legacy styles (kept for compatibility)
  infoTextTitle: {
    color: "white",
    fontSize: "11px",
    marginBottom: "28.5px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "19px",
    },
  },
  infoText: {
    color: "white",
    marginBottom: "60px",
    fontSize: "14px",
  },
  radioCircle: {
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "2px solid transparent",
    backgroundColor: "#fff",
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginRight: 8,
  },
  selected: {
    border: "5px solid #007BFF",
  },
  inputField: {
    width: "100%",
    height: "42px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& .MuiInputBase-root": {
      color: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EDECED",
      },
      "&:hover fieldset": {
        borderColor: "#f06ec4",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#f06ec4",
      },
    },
    "& .MuiInputLabel-root": {
      color: "#999999",
    },
  },
  saveButton: {
    backgroundColor: "#f06ec4",
    color: "white",
    "&:hover": {
      backgroundColor: "#d45ca5",
    },

    textTransform: "none",
    borderRadius: "8px",
    padding: "8px 16px",
  },
  fieldLabel: {
    color: "white",
    fontSize: "11px",
    whiteSpace: "nowrap",
  },
  labelUnput: {
    marginRight: "116px",
    width: "120px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    marginBottom: "8px",
  },
  bottomLine: {
    marginTop: "80px",
    borderBottom: "1px solid #363636",
    width: "100%",
  },
  fieldLabell: {
    color: "white",
    fontSize: "10px",
    marginTop: "29px",
    marginLeft: "16px",
    marginBottom: "15px",
  },
  formGroup: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      alignItems: "flex-start",
      flexDirection: "column",
      columnGap: "0px",
    },
  },
  paymentMethodItem: {
    height: "64px",
    padding: "0 38px",
    backgroundColor: "#1E1E1E",
    borderRadius: "8px",
    marginLeft: "18px",
    marginBottom: "6px",
    display: "flex",
    alignItems: "center",
    border: "1px solid #EDECED",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      margin: "3px 4px 0 0",
    },
  },
  card: {
    width: "150px",
  },
  cardIcon: {
    width: 28,
    height: 50,
    color: "#f06ec4",
    marginRight: theme.spacing(2),
    marginLeft: "8px",
  },
  deleteIcon: {
    width: 16,
    height: 16,
    color: "white",
    position: "absolute",
    top: 8,
    right: 8,
    cursor: "pointer",
    "&:hover": {
      color: "#f00",
    },
  },
  rect: {
    width: 28,
    height: 100,
  },
  cardDetails: {
    flex: 1,
    marginLeft: 7,
  },
  cardName: {
    color: "white",
    fontWeight: 500,
    fontSize: "10px",
  },
  cardNumber: {
    color: "#999999",
  },
  cardExpiry: {
    color: "#999999",
    marginTop: "0",
    fontSize: "10px",
  },
  temporaryDeactivate: {
    color: "#f06ec4",
    fontSize: "12px",
    cursor: "pointer",
    textAlign: "center",
    margin: "20px 0 10px 0",
  },
  footerButton: {
    marginTop: "54px",
    display: "flex",
    justifyContent: "flex-end",
  },
  proceedButton: {
    backgroundColor: "#ff69b4",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 600,
    padding: "10px 24px",
    borderRadius: "8px",
    textTransform: "none",
    marginBottom: "16px",
    fontFamily: "Work Sans, sans-serif",
    "&:hover": {
      backgroundColor: "#ff85c1",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(255, 105, 180, 0.3)",
    },
    transition: "all 0.3s ease",
    //  width: "100%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      padding: "12px 20px",
    },
  },
}));
